import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Retry transient failures (server waking up, network blip) — only a real
    // 401/403 means "not logged in". Prevents bouncing a valid session to "/".
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
        setLoading(false);
        return;
      } catch (e) {
        const status = e?.response?.status;
        if (status === 401 || status === 403) break;
        if (attempt < 2) await new Promise((res) => setTimeout(res, 1000 * (attempt + 1)));
      }
    }
    setUser(null);
    setLoading(false);
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me check if returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
